import { getCurrentInstance, onBeforeUnmount, ref, unref } from 'vue';
import SalesTransactionsAPI from 'dashboard/api/salesTransactions';

const SOURCES = ['funesbom', 'efiteutica'];
const minimumInscriptionLength = 7;

const loadingChecks = () =>
  SOURCES.map(source => ({ source, status: 'loading' }));
const unavailableChecks = () =>
  SOURCES.map(source => ({ source, status: 'unavailable' }));

export function useSalesPropertyCertificateChecks({ id, closeDelay = 5000 }) {
  const checks = ref([]);
  const checking = ref(false);
  const visible = ref(false);
  let closeTimer;

  const close = () => {
    clearTimeout(closeTimer);
    visible.value = false;
  };
  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, closeDelay);
  };
  const run = async ({ inscricao, municipio } = {}) => {
    const registration = String(inscricao || '').replace(/\D/g, '');
    if (
      checking.value ||
      registration.length < minimumInscriptionLength ||
      !String(municipio || '').trim()
    ) {
      return null;
    }

    clearTimeout(closeTimer);
    checks.value = loadingChecks();
    checking.value = true;
    visible.value = true;
    try {
      const response = await SalesTransactionsAPI.propertyCertificateChecks(
        unref(id),
        { inscricao: registration, municipio }
      );
      checks.value = response?.data?.checks || unavailableChecks();
      return response?.data || null;
    } catch {
      checks.value = unavailableChecks();
      return null;
    } finally {
      checking.value = false;
      scheduleClose();
    }
  };

  if (getCurrentInstance()) onBeforeUnmount(close);

  return { checks, checking, close, run, visible };
}
